import Link from "next/link";
import styled from "styled-components";
import { COLORS } from "@/constants";
import { Typography } from "@mui/material";

export const Container = styled.div`
  position: relative;
  max-width: 100%;
  min-height: 100vh;
  background-color: #f9f7f1;
`;
export const Content = styled.div`
  height: 100%;
  max-width: 733px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
`;
export const Logo = styled(Link)`
  margin-top: 66px;
  display: block;
  width: 259px;
  height: 32px;

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
export const IllustrationWrapper = styled.div`
  margin-top: 57px;
  width: 278px;
  height: 281px;

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
export const TextWrapper = styled.div`
  margin-top: 43px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
`;
export const Title = styled.h1`
  margin: 0;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-style: bold;
  font-weight: 700;
  font-size: 36px;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: center;
  color: ${COLORS.blue};
`;
export const TextAccent = styled(Typography)`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 600;
  font-size: 17px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  color: ${COLORS.accentTextColor};
`;
export const DescriptionWrapper = styled.div`
  margin-top: 43px;
  display: flex;
  align-items: center;
  gap: 24px;
`;
export const Text = styled(Typography)`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: ${COLORS['primary/950']};
`;
export const Delimiter = styled.div`
  height: -webkit-fill-available;
  width: 2px;
  background-color: #D0BAA7;
`;
export const TextLink = styled.a`
  color: ${COLORS['primary/600']};
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;
export const Footer = styled.div`
  margin-top: 70px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  color: ${COLORS['gray-dark']};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 14px;
`;
export const FooterText = styled.span`
  color: ${COLORS['gray-dark']};
`;
export const Separator = styled.span`
  font-size: 16px;
  color: ${COLORS['neutral/300']};
`;
export const FooterLink = styled.a`
  color: ${COLORS['primary/900']};
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;